const SET_USERS = (state, users) => {
  state.users = users
}

const SET_USER = (state, user) => {
  state.user = user
}

const PUSH = (state, user) => {
  state.users.push(user)
  state.user = {}
}

const RESET = (state) => {
  state.user = {}
}

const UPDATE = (state, data) => {
  let user = state.users.find(user => user.id === data.id)

  user.firstname = data.firstname
  user.lastname = data.lastname
  user.email = data.email
  user.scopes = data.scopes
}

const REMOVE = (state, userId) => {
  let idx = state.users.findIndex(x => x.id === userId)
  state.users.splice(idx, 1)
}

const SET_SCOPE = (state, params) => {
  let user = state.users.find(user => user.id === params.user_id)
  let idx = user.scopes.findIndex(scope => scope === params.scope_id)

  if (idx !== -1) {
    user.scopes.splice(idx, 1)
  } else {
    user.scopes.push(params.scope_id)
  }
}

const SET_AUTHORISATION = (state, data) => {
  state.isAuthorised = data.isAuthorised
}

export default {
  PUSH,
  RESET,
  UPDATE,
  REMOVE,
  SET_USER,
  SET_USERS,
  SET_SCOPE,
  SET_AUTHORISATION
}
